import React from "react";
import ArtistDetail from "./ArtistDetail";

class ArtistOverview extends React.Component{
    render () {
        return( 
            <div>
                <ArtistDetail artistId="5fbf764525851826683022a4"/>
            </div>
        ) 
    }
}

export default ArtistOverview;